import { createFileRoute } from '@tanstack/react-router';
import { SponsoredFormPage } from '@/features/sponsored/pages/SponsoredFormPage';

export const Route = createFileRoute('/_authed/ops/sponsored/new')({
  staticData: { help: 'sponsored' },
  component: () => <SponsoredFormPage />,
});
